import React from "react";

export default ({size}) => {
    return <span className={`spinner-border spinner-border-${size || 'sm'} mr-1`} role="status"
                 aria-hidden="true"></span>
}
